import { useRouter } from "next/router";

const HOMEPAGE_PATHNAME = "/[language]/[[...slug]]";
const SLUG_QUERY_PARAM = "slug";

const useExtendedRouter = () => {
  const router = useRouter();
  const { pathname, query } = router;

  const isHomepage = pathname === HOMEPAGE_PATHNAME && !Object.prototype.hasOwnProperty.call(query, SLUG_QUERY_PARAM);

  return { ...router, isHomepage };
};

export default useExtendedRouter;
